import { render, staticRenderFns } from "./SwiperPartners.vue?vue&type=template&id=44da4668&"
import script from "./SwiperPartners.vue?vue&type=script&lang=js&"
export * from "./SwiperPartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports